import { render, staticRenderFns } from "./tiyan.vue?vue&type=template&id=0d5a63a3&scoped=true&"
import script from "./tiyan.vue?vue&type=script&lang=js&"
export * from "./tiyan.vue?vue&type=script&lang=js&"
import style0 from "./tiyan.vue?vue&type=style&index=0&id=0d5a63a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5a63a3",
  null
  
)

export default component.exports